// import JsBarcode from 'jsbarcode';
import React, { useRef, useEffect } from 'react';
import { useBarcode } from 'react-barcodes';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
const useStyles = makeStyles((theme) => ({
  // root: {
  //   paddingTop: theme.spacing(1),
  //   paddingBottom: theme.spacing(1),
  //   // width: '189px',
  //   // height: '94px'
  // },

}));

function BarcodeGenerator({ KUL_URETICI_KODU, KUL_BIRIM_KODU, FIS_NO, KRITIK, ADET, MALZEME_STOK_NO
  , MALZEME, UYIL, UDONEM, KUL_MODEL_KODU, MODEL, MALZEME_KODU }) {
  const classes = useStyles();
  var KritikKontrol = "0";

  var Barcode = "";
  if (KRITIK === "K") {
    Barcode = "1" + FIS_NO + MALZEME_KODU;
    KritikKontrol = "1";
  } else {
    Barcode = "0" + FIS_NO + MALZEME_KODU;
  }
  const { inputRef } = useBarcode({
    value: Barcode,
    options: {
      displayValue: false
      , flat: true
      , margin: 0
      , format: "CODE128"
      , height: 33
      , width: 1.3
    }
  });


  return (
    <table border="0" style={{
      width: '100%', borderCollapse: 'collapse', fontFamily: 'monospace', fontSize: 9
    }}>

      <tr style={{ padding: '0px' }}>
        <td align='left' style={{ width: '5%', padding: '0px' }}>{KUL_URETICI_KODU}</td>
        <td align='center' style={{ width: '55%', padding: '0px' }}>{KUL_BIRIM_KODU}</td>
        <td align='left' style={{ width: '20%', padding: '0px' }}>{FIS_NO}</td>
        <td align='center' style={{ width: '20%', padding: '0px' }}>{KRITIK}</td>
      </tr>
      <tr style={{ padding: '0px' }}>
        {/* <td align='center' style={{padding:'0px'}}>{KritikKontrol}</td> */}
        <td colSpan={4} align='left' style={{ padding: '0px' }}>
          <table style={{ padding: '0px' }}>
            <tr style={{ padding: '0px' }}>
              <td align='left' style={{ padding: '0px',fontSize: 8 }}>{ADET}</td>
              <td align='left' style={{ padding: '0px' }}><svg ref={inputRef} /></td>
            </tr>
          </table>
          
        </td>
      </tr>
      <tr style={{ padding: '0px' }}>
        <td colSpan={4} align='left' style={{ fontSize: 7, padding: '0px' }}>{(MALZEME_STOK_NO + "-" + MALZEME).substring(0, 40)}</td>
      </tr>
      <tr style={{ padding: '0px' }}>
        <td colSpan={4} align='left' style={{ fontSize: 7, padding: '0px' }}>{(UYIL + "/" + UDONEM + " " + KUL_MODEL_KODU + " " + MODEL).substring(0, 40)}</td>
      </tr>
      <tr>
        <td colSpan={4} align='left' style={{  padding: '0px', height: '30px' }}></td>
      </tr>
    </table >

  );
}

export default BarcodeGenerator;
